import React, { useEffect, useState } from 'react';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import FailureNotification from './FailuresList';
import * as api from '../../../../services/apis';

const FailuresListContainer = () => {
  const [failuresList, setFailuresList] = useState([]);
  const [originalFailures, setOriginalFailures] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  const { logout, userInfo } = useAuthentication();

  const getFailuresList = (taxNumber) => {
    api
      .getTechnicalFailureList(taxNumber)
      .then((resp) => {
        setOriginalFailures(resp?.data || []);
        setFailuresList(resp?.data || []);
        setTableLoading(false);
      })
      .catch((err) => {
        if (err?.status === 401) {
          // eslint-disable-next-line no-undef
          logout({ redirect: location.pathname });
        }
        setTableLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getFailuresList(userInfo.tax_number);
    }
  }, [userInfo]);

  return (
    <FailureNotification
      renderedFailures={failuresList}
      originalFailures={originalFailures}
      setFailuresList={setFailuresList}
      tableLoading={tableLoading}
    />
  );
};

export default FailuresListContainer;
